module.exports = __webpack_public_path__ + "img/outraativ.03f8145c.png";